// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import SvgIconStyle from '../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle src={`${process.env.REACT_APP_BASENAME}/static/icons/navbar/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);

const ICONS = {
  user: getIcon('ic_user'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  blog: getIcon('ic_blog'),
  link: getIcon('ic_link'),
  video: getIcon('ic_video'),
  contact: getIcon('ic_contact'),
  decision: getIcon('ic_decision'),
  anitbiotic: getIcon('ic_anitbiotic'),
  classification: getIcon('ic_classification'),
  overview: getIcon('ic_overview'),
  guidlines: getIcon('ic_guidlines'),
  categories: getIcon('ic_category'),
  subcategories: getIcon('ic_subcategory')
};

const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  // {
  //   subheader: 'general',
  //   items: [
  //     {
  //       title: 'user',
  //       path: PATH_DASHBOARD.user.root,
  //       icon: ICONS.user
  //     }
  //     // { title: 'One', path: PATH_DASHBOARD.general.pageOne, icon: ICONS.dashboard },
  //     // { title: 'Two', path: PATH_DASHBOARD.general.pageTwo, icon: ICONS.ecommerce },
  //     // { title: 'Three', path: PATH_DASHBOARD.general.pageThree, icon: ICONS.analytics }
  //   ]
  // },
  // MANAGEMENT
  // ----------------------------------------------------------------------

  {
    subheader: 'general',
    items: [
      {
        title: 'categories',
        path: PATH_DASHBOARD.categories.root,
        icon: ICONS.categories
      },
      {
        title: 'subcategories',
        path: PATH_DASHBOARD.subcategories.root,
        icon: ICONS.subcategories
      },
      // {
      //   title: 'add to subcategories',
      //   path: PATH_DASHBOARD.addToSub.root,
      //   icon: ICONS.subcategories
      // },
      {
        title: 'decision making',
        path: PATH_DASHBOARD.decision.root,
        icon: ICONS.decision
      },
      {
        title: 'antibiotics',
        path: PATH_DASHBOARD.antibiotics.root,
        icon: ICONS.anitbiotic
      },
      {
        title: 'classifications',
        path: PATH_DASHBOARD.classifications.root,
        icon: ICONS.classification
      },
      {
        title: 'overview',
        path: PATH_DASHBOARD.overview.root,
        icon: ICONS.overview
      },
      {
        title: 'guidelines',
        path: PATH_DASHBOARD.guidlines.root,
        icon: ICONS.guidlines
      }
    ]
  },
  {
    subheader: 'management',
    items: [
      {
        title: 'static pages',
        path: PATH_DASHBOARD.page.posts,
        icon: ICONS.blog
      },
      {
        title: 'Enquiry',
        path: PATH_DASHBOARD.enquiry.root,
        icon: ICONS.contact
      },
      {
        title: 'Refrences',
        path: PATH_DASHBOARD.refrences.root,
        icon: ICONS.link
      },
      {
        title: 'Video',
        path: PATH_DASHBOARD.video.root,
        icon: ICONS.video
      }
    ]
  }
];

export default sidebarConfig;
